import React from "react";
import useStyles from "./styles";
import { Box } from "@material-ui/core";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const GridSkeleton = () => {
  const classes = useStyles();
  const dyanmicWidth = (width) => (
    <Box width={width}>
      <Skeleton height={18} />
    </Box>
  );
  const SkeletonDisplay = () => (
    <Box
      className={`${classes.gridSkeleton} grid-skeleton`}
      display="flex"
      justifyContent="space-between"
    >
      {dyanmicWidth("5%")}
      {dyanmicWidth("25%")}
      {Array(5)
        .fill(1)
        .map(() => dyanmicWidth("10%"))}
      {dyanmicWidth("5%")}
    </Box>
  );
  return (
    <>
      {Array(7)
        .fill(1)
        .map(() => (
          <SkeletonDisplay />
        ))}
    </>
  );
};

export default GridSkeleton;
